import { Component, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { SelectionEvent, SelectableSettings } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { OrderDetailsSelectBus } from '@app/cp/shared/models/OrderDetailsSelectBus';
import { GridComponent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'order-item-select',
    templateUrl: './order-item-select.component.html',
    styleUrls: ['./order-item-select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OrderItemsSelectComponent  {

    constructor(public globals: GlobalsService, svc_data: OrderService) {
        this.svc_data = svc_data;
        this.setSelectableSettings();
    }
    parentId: any;
    public selectableSettings: SelectableSettings;
    public setSelectableSettings(): void {
        this.selectableSettings = {
            checkboxOnly: true,
            mode: 'multiple'
        };
    }
    public setup(data: string, forceRefresh: boolean = false,orderBillId = null) {
        if (this.parentId !== data || forceRefresh === true) {
            this.parentId = data;
            if (orderBillId) {
                this.svc_data.getOrderDetailsByBillSelectItems(data, orderBillId).subscribe((info: BaseMessageInfo) => {
                    if (!info.saveError) {
                        if (CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                            let arr = [];
                            for (let i = 0; i < info.primaryReturn.length; i++) {
                                let busObj: OrderDetailsSelectBus = new OrderDetailsSelectBus(info.primaryReturn[i]);
                                arr.push(busObj);
                            }
                            this.gridData = arr;
                        }
                    }
                });


            }
            else {
                this.svc_data.getOrderDetailsSelectItems(data).subscribe((info: BaseMessageInfo) => {
                    if (!info.saveError) {
                        if (CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                            let arr = [];
                            for (let i = 0; i < info.primaryReturn.length; i++) {
                                let busObj: OrderDetailsSelectBus = new OrderDetailsSelectBus(info.primaryReturn[i]);
                                arr.push(busObj);
                            }
                            this.gridData = arr;
                        }
                    }
                });
            }
}
        else {
            this.gridData = this.gridData.filter(s => s.selected !== true);
        }
    }
    getSelectedRows() : OrderDetailsSelectBus[] {
        let arr = [];
        for (let i = 0; i < this.gridData.length; i++) {
            if (this.gridData[i].selected) {
                let busObj: OrderDetailsSelectBus = new OrderDetailsSelectBus(this.gridData[i]);
                arr.push(busObj);
            }
        }
        return arr;
    }

    @Input()
    gridData: OrderDetailsSelectBus[];
    svc_data: OrderService;
    selectedData: OrderDetailsSelectBus;
    @ViewChild('grid') protected grid: GridComponent;
    @ViewChild('detail') protected detail: null;
    @Output() selected: EventEmitter<any> = new EventEmitter();
    @Input() readOnly: boolean = false;
    dataLoading: boolean = false;
    pageSize: number;
    skip: number;

    rowSelected(e: SelectionEvent) {
        this.selectedData = e.selectedRows[0].dataItem;
    }
    select(e: OrderDetailsSelectBus) {
        this.selected.emit(e);
    }
}
